const shijuanguanli = { // 试题库
  path: 'shijuanguanli',
  name: 'shijuanguanli',
  meta: {
    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
  },
  component: resolve=> {
    require.ensure([], () => {
      resolve(require('_c/kaoshi/shijuanguanli/shijuanguanli_list'))
    }, 'shijuanguanli')
  }
}
const kaoshishezhi = { // 考试设置
  path: 'kaoshishezhi',
  name: 'kaoshishezhi',
  meta: {
    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
  },
  component: resolve=> {
    require.ensure([], () => {
      resolve(require('_c/kaoshi/kaoshishezhi/kaoshishezhi_list'))
    }, 'kaoshishezhi')
  }
}
const shijuanlianxi = { // 试卷练习
  path: 'shijuanlianxi',
  name: 'shijuanlianxi',
  meta: {
    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
  },
  component: resolve=> {
    require.ensure([], () => {
      resolve(require('_c/kaoshi/shijuanlianxi/shijuanlianxi_list'))
    }, 'shijuanlianxi')
  }
}
const shougongyuejuan = { // 手工阅卷
  path: 'shougongyuejuan',
  name: 'shougongyuejuan',
  meta: {
    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
  },
  component: resolve=> {
    require.ensure([], () => {
      resolve(require('_c/kaoshi/shougongyuejuan/shougongyuejuan_list'))
    }, 'shougongyuejuan')
  }
}
const jiankao = { // 监考
  path: 'jiankao',
  name: 'jiankao',
  meta: {
    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
  },
  component: resolve=> {
    require.ensure([], () => {
      resolve(require('_c/kaoshi/jiankao/jiankao_list'))
    }, 'jiankao')
  }
}
const kaochangguanli = { // 考场管理
  path: 'kaochangguanli',
  name: 'kaochangguanli',
  meta: {
    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
  },
  component: resolve=> {
    require.ensure([], () => {
      resolve(require('_c/kaoshi/kaochangguanli/kaochangguanli_list'))
    }, 'kaochangguanli')
  }
}
const paikaoshezhi = { // 排考设置
  path: 'paikaoshezhi',
  name: 'paikaoshezhi',
  meta: {
    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
  },
  component: resolve=> {
    require.ensure([], () => {
      resolve(require('_c/kaoshi/paikaoshezhi/arrangeName'))
    }, 'paikaoshezhi')
  }
}
const signin = { // 排考设置
  path: 'signin',
  name: 'signin',
  meta: {
    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
  },
  component: resolve=> {
    require.ensure([], () => {
      resolve(require('_c/kaoshi/jiankao/signin'))
    }, 'signin')
  }
}
const signincode = { // 排考设置
  path: 'signincode',
  name: 'signincode',
  meta: {
    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
  },
  component: resolve=> {
    require.ensure([], () => {
      resolve(require('_c/kaoshi/kaoshijiankong/signincode'))
    }, 'signincode')
  }
}
const kaoshijiankong = { // 排考设置
  path: 'kaoshijiankong',
  name: 'kaoshijiankong',
  meta: {
    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
  },
  component: resolve=> {
    require.ensure([], () => {
      resolve(require('_c/kaoshi/kaoshijiankong/kaoshijiankong_list'))
    }, 'kaoshijiankong')
  }
}
export {
  shijuanguanli,
  kaoshishezhi,
  shijuanlianxi,
  shougongyuejuan,
  jiankao,
  kaochangguanli,
  paikaoshezhi,
  signin,
  signincode,
  kaoshijiankong
}
